import React, { useState, useEffect } from "react";
import axios from "axios";
import BasicTable from "../BasicTable/BasicTable";
import { DataGrid } from "@mui/x-data-grid";

const columns = [
  { field: "_id", headerName: "ID", width: 100 },
  { field: "restaurantName", headerName: "Name", width: 190, flex: 0.5 },
  { field: "restaurantAddress", headerName: "Location", width: 130, flex: 0.8 },
  { field: "Due", headerName: "Due", width: 130, flex: 0.4 },
  { field: "restaurantType", headerName: "Type", width: 130, flex: 0.4 },
  { field: "restaurantRating", headerName: "Rating", width: 130 },
  { field: "restaurantOwner", headerName: "Owner", width: 130, flex: 0.5 },
];

function FeaturedTable({ allRestaurants }) {
  const [selectedRestaurants, setSelectedRestaurants] = useState([]);
  const [selectionModel, setSelectionModel] = useState();
  const [update, setUpdate] = useState(true);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let mounted = true;

    const fetchSelectedRestaurants = async () => {
      try {
        const res = await axios.get("/restaurant/get-featured-restaurants");
        setSelectedRestaurants(res.data.featuredRestaurants);
      } catch (e) {
        console.log(e);
      }
    };
    fetchSelectedRestaurants();

    return () => {
      mounted = false;
    };
  }, [update]);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      setSelectionModel(selectedRestaurants?.map((r) => r._id));
    }
    return () => {
      mounted = false;
    };
  }, [selectedRestaurants]);

  const updateFeatured = async (values) => {
    const body = { restaurantID: values };
    try {
      const res = await axios.post(
        "https://resto-app-user.herokuapp.com/add-featured-restaurants",
        body
      );
    } catch (e) {
      console.log(e);
    }
    setUpdate((prev) => !prev);
    setOpen(false);
  };

  return (
    <div style={{ backgroundColor: "white", padding: "10px 5px 20px" }}>
      {open ? (
        <>
          <div className="w-full text-center text-xl pt-5 pb-2">
            Update Featured Restaurants
          </div>
          <div className="p-8 pt-3">
            <div style={{ height: 400, width: "100%" }}>
              <DataGrid
                rows={allRestaurants}
                columns={columns}
                getRowId={(row) => row._id}
                pageSize={5}
                rowsPerPageOptions={[5]}
                checkboxSelection
                selectionModel={selectionModel}
                onSelectionModelChange={setSelectionModel}
              />
            </div>
            <div>
              <button
                className="w-full bg-green-500 text-white py-2 px-3 rounded-sm border-none"
                onClick={(e) => updateFeatured(selectionModel)}
              >
                Update Linked Restaurants
              </button>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="restaurant-table-header">
            <h6>Total Featured Restaurants : {selectedRestaurants.length}</h6>
            <button
              className="w-30 bg-red-500 text-white py-2 px-3 rounded-sm text-sm border-none"
              onClick={(e) => setOpen(true)}
            >
              Update Linked Restaurants
            </button>
          </div>
          <div style={{ padding: "5px 20px" }}>
            <BasicTable restaurants={selectedRestaurants} />
          </div>
        </>
      )}
    </div>
  );
}

export default FeaturedTable;
